import React  from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import strip from "striptags";

export default function Parents() {  

    let app = ApplicantContainer.useContainer();    
    
    let inputCCParents = app.inStdValues.frParentGuardian;

    function handleChange(evt) {
                
        if((' frParentCCAgeOne frCCParentIncomeOne frCCParentOtherIncomeOne frParentCCAgeTwo frCCParentIncomeTwo frCCParentOtherIncomeTwo').search(evt.target.name) > 0)
            evt.target.value = evt.target.value.replace(/\D/g,'');
        
        if((' frICPassportOne  frICPassportTwo').search(evt.target.name) > 0) 
            evt.target.value = evt.target.value.replace(/[^a-z0-9]/gi,'');

        evt.target.value = strip(evt.target.value);
        
        const values = inputCCParents;        
        values[evt.target.name] =  evt.target.value;
        
        app.onChangeInStdValues({...app.inStdValues, frParentGuardian:values}); 
    }

    

    return (    
    <>
        <Form.Row>
        <Col xs={12}>            
            <Form.Group as={Col} controlId="formName">
            <Form.Label className="h6">Parents/Guardians Information</Form.Label>
            </Form.Group>
        </Col>  
        </Form.Row>
        <Form.Row>
        <Col xs={12} lg={6} >        
            <Form.Row>                     
            <Col xs={12}>
            <Form.Group as={Col} className="ml-1 mb-3" onChange={handleChange} >                
                <Form.Check inline label="Father" value="Father" name="frCCParentChoiceOne" id="frCCParentChoiceOneFather" type="radio"  required />
                <Form.Check inline label="Mother" value="Mother" name="frCCParentChoiceOne" id="frCCParentChoiceOneMother" type="radio"  required />
                <Form.Check inline label="Guardian" value="Guardian" name="frCCParentChoiceOne" id="frCCParentChoiceOneGuardian" type="radio"  required />
                </Form.Group>
            </Col>
            </Form.Row>

            <Form.Row className="flex">
                <Col xs={12} sm={6}>
                    <Form.Group as={Col} controlId="frCCParentNameOne">
                    <Form.Label>Name</Form.Label>
                    <Form.Control name="frCCParentNameOne" required type="input" onChange={handleChange} value={inputCCParents.frCCParentNameOne} />
                </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                    <Form.Group as={Col} controlId="frCCParentICPasportOne">
                    <Form.Label>IC / Passport No.</Form.Label>
                    <Form.Control name="frCCParentICPasportOne" required type="input" onChange={handleChange} value={inputCCParents.frCCParentICPasportOne}/>
                </Form.Group>
                </Col>
                <Col xs={12} sm={2}>
                    <Form.Group as={Col} controlId="frParentCCAgeOne">
                    <Form.Label>Age</Form.Label>
                    <Form.Control name="frParentCCAgeOne" type="input" onChange={handleChange} value={inputCCParents.frParentCCAgeOne}/>
                </Form.Group>
                </Col>           
            </Form.Row>
            
            <Form.Row>
                <Col xs={12} sm={2}>
                    <Form.Group as={Col}>                
                    <Form.Label>Status</Form.Label>
                    </Form.Group>
                </Col>   
                <Col xs={12} sm={10}>
                    <Form.Group as={Col} onChange={handleChange}>
                    <div key="inline-radio" className="mb-3">
                    <Form.Check inline label="Single" value="Single" name="frCCParentStatusOne" id="frCCParentStatusOneSingle" type="radio"  />
                    <Form.Check inline label="Married" value="Married" name="frCCParentStatusOne" id="frCCParentStatusOneMaried" type="radio"  />
                    <Form.Check inline label="Separated" value="Separated" name="frCCParentStatusOne" id="frCCParentStatusOneSeparated" type="radio"  />
                    <Form.Check inline label="Divorced" value="Divorced" name="frCCParentStatusOne" id="frCCParentStatusOneDivorced" type="radio"  />
                    <Form.Check inline label="Deceased" value="Deceased" name="frCCParentStatusOne" id="frCCParentStatusOneDeceased" type="radio"  />
                    </div>  
                    </Form.Group>
                </Col>
            </Form.Row>

            <Form.Row>
                 <Col xs={12} sm={4}>
                    <Form.Group as={Col} controlId="frCCParentEmployTypeOne" onChange={handleChange}>
                    <Form.Label>Employment</Form.Label>
                    <Form.Control as="select" required 
                        name="frCCParentEmployTypeOne"
                    >
                    <option key="" value=""></option>
                    <option key='Unemployed' value='Unemployed'>Unemployed</option>
                    <option key='Employed' value='Employed'>Employed</option>  
                    <option key='SelfEmployed' value='SelfEmployed'>Self-Employed</option>            
                    </Form.Control>
                    </Form.Group>
                </Col>
                <Col xs={12} sm={8}>
                    <Form.Group as={Col} controlId="frCCParentOccupationOne">
                    <Form.Label>Occupation</Form.Label>
                    <Form.Control name="frCCParentOccupationOne" type="input" onChange={handleChange} value={inputCCParents.frCCParentOccupationOne}/>
                </Form.Group>
                </Col>
            </Form.Row>

            <Form.Row className="flex">
           
                <Col xs={12}>                    
                    <Form.Group as={Col} htmlFor="frCCParentWorkAddrOne" controlId="frCCParentWorkAddrOne" onChange={handleChange} value={inputCCParents.frCCParentWorkAddrOne}>
                    <Form.Label>Name & Address of Employers</Form.Label>
                    <Form.Control name="frCCParentWorkAddrOne" as="textarea" rows={3} 
                                        />                                          
                    </Form.Group>
                </Col>
                <Col xs={12}>
                <Form.Row>
                    <Col xs={12} md={4}>
                    <Form.Group as={Col} controlId="frCCParentIncomeOne">
                    <Form.Label>Monthly Income (RM)</Form.Label>
                    </Form.Group>
                    </Col>
                    <Col xs={12} md={2}>
                    <Form.Group as={Col} controlId="frCCParentIncomeOne">
                    <Form.Control name="frCCParentIncomeOne" type="input" onChange={handleChange} value={inputCCParents.frCCParentIncomeOne}/>
                    </Form.Group>                
                    </Col>
                    <Col xs={12} md={4}>
                    <Form.Group as={Col} controlId="frCCParentOtherIncomeOne">
                        <Form.Label>Income from other sources (RM)</Form.Label>
                    </Form.Group></Col>
                    <Col xs={12} md={2}>
                    <Form.Group as={Col} controlId="frCCParentOtherIncomeOne">
                        <Form.Control name="frCCParentOtherIncomeOne" type="input" onChange={handleChange} value={inputCCParents.frCCParentOtherIncomeOne}/>
                    </Form.Group>
                    </Col>
                    </Form.Row>
                </Col>
            </Form.Row>              
        </Col>
        <Col xs={12} lg={6} >               
        <Form.Row>                        
            <Col xs={12}>
                
            <Form.Group as={Col} className="ml-1 mb-3" onChange={handleChange}>                
                <Form.Check inline label="None" value="" name="frCCParentChoiceTwo" id="frCCParentChoiceTwoNone" type="radio" />
                <Form.Check inline label="Mother" value="Mother" name="frCCParentChoiceTwo" id="frCCParentChoiceTwoMother" type="radio"/>
                <Form.Check inline label="Guardian" value="Guardian" name="frCCParentChoiceTwo" id="frCCParentChoiceTwoGuardian" type="radio" />                
            </Form.Group>                
                         
            </Col>
            </Form.Row>

        <Form.Row className="flex">
            <Col xs={12} sm={6}>
                <Form.Group as={Col} controlId="frCCParentNameTwo">
                <Form.Label>Name</Form.Label>
                <Form.Control name="frCCParentNameTwo" type="input" onChange={handleChange} value={inputCCParents.frCCParentNameTwo}/>
            </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
                <Form.Group as={Col} controlId="frCCParentICPasportTwo">
                <Form.Label>IC / Passport No.</Form.Label>
                <Form.Control name="frCCParentICPasportTwo" type="input" onChange={handleChange} value={inputCCParents.frCCParentICPasportTwo}/>
            </Form.Group>
            </Col>
            <Col xs={12} sm={2}>
                <Form.Group as={Col} controlId="frParentCCAgeTwo">
                <Form.Label>Age</Form.Label>
                <Form.Control name="frParentCCAgeTwo" type="input" onChange={handleChange} value={inputCCParents.frParentCCAgeTwo}/>
            </Form.Group>
            </Col>           
        </Form.Row>
        
        <Form.Row>
            <Col xs={12} sm={2}>
                <Form.Group as={Col} >                
                <Form.Label>Status</Form.Label>
                </Form.Group>
            </Col>   
            <Col xs={12} sm={10}>
                <Form.Group as={Col} onChange={handleChange}>
                <div key="inline-radio" className="mb-3">
                <Form.Check inline label="Single" value="Single" name="frCCParentStatusTwo" id="frCCParentStatusTwoSingle" type="radio" />
                <Form.Check inline label="Married" value="Married" name="frCCParentStatusTwo" id="frCCParentStatusTwoMarried" type="radio" />
                <Form.Check inline label="Separated" value="Separated" name="frCCParentStatusTwo" id="frCCParentStatusTwoSeparated" type="radio" />
                <Form.Check inline label="Divorced" value="Divorced" name="frCCParentStatusTwo" id="frCCParentStatusTwoDivorced" type="radio" />
                <Form.Check inline label="Deceased" value="Deceased" name="frCCParentStatusTwo" id="frCCParentStatusTwoDeceased" type="radio" />
                </div>  
                </Form.Group>
            </Col>
        </Form.Row>

        <Form.Row>
             <Col xs={12} sm={4}>
                <Form.Group as={Col} controlId="frCCParentEmployTypeTwo" onChange={handleChange}>
                <Form.Label>Employment</Form.Label>
                <Form.Control as="select" 
                 name="frCCParentEmployTypeTwo"
                 >
                <option key="" value=""></option>
                <option key='Unemployed' value='Unemployed'>Unemployed</option>
                <option key='Employed' value='Employed'>Employed</option>  
                <option key='SelfEmployed' value='SelfEmployed'>Self-Employed</option>            
                </Form.Control>
                </Form.Group>
            </Col>
            <Col xs={12} sm={8}>
                <Form.Group as={Col} controlId="frCCParentOccupationTwo"  >
                <Form.Label>Occupation</Form.Label>
                <Form.Control name="frCCParentOccupationTwo" type="input" onChange={handleChange} />
            </Form.Group>
            </Col>
        </Form.Row>

        <Form.Row className="flex">
       
            <Col xs={12}>
            <Form.Group as={Col} htmlFor="frCCParentWorkAddrTwo" controlId="frCCParentWorkAddrTwo"  onChange={handleChange} value={inputCCParents.frCCParentWorkAddrTwo}>
            <Form.Label>Name & Address of Employers</Form.Label>
            <Form.Control  as="textarea" rows={3} name="frCCParentWorkAddrTwo"
                                />                                          
            </Form.Group>
            </Col>
            <Col xs={12}>
            <Form.Row>
                <Col xs={12} sm={4}>
                <Form.Group as={Col} controlId="frCCParentIncomeTwo"  >
                <Form.Label>Monthly Income (RM)</Form.Label>
                </Form.Group>
                </Col>
                <Col xs={12} sm={2}>
                <Form.Group as={Col} controlId="frCCParentIncomeTwo"  >
                <Form.Control name="frCCParentIncomeTwo" type="input" onChange={handleChange} value={inputCCParents.frCCParentIncomeTwo}/>
                </Form.Group>                
                </Col>
                <Col xs={12} sm={4}>
                <Form.Group as={Col} controlId="frCCParentOtherIncomeTwo"  >
                    <Form.Label>Income from other sources (RM)</Form.Label>
                </Form.Group></Col>
                <Col xs={12} sm={2}>
                <Form.Group as={Col} controlId="frCCParentOtherIncomeTwo"  >
                    <Form.Control name="frCCParentOtherIncomeTwo" type="input" onChange={handleChange} value={inputCCParents.frCCParentOtherIncomeTwo}/>
                </Form.Group>
                </Col>
                </Form.Row>
            </Col>
        </Form.Row>          
        </Col>
        </Form.Row>
    </>
    );
}